// generated by genversion
export var version = '3.5.5';
//# sourceMappingURL=version.js.map